<!-- MODAL -->
<ng-template #direNotFoundOptions let-c="close">

  <div class="modal-header">
    <h5 class="modal-title" id="direModalLongTitle" translate>pub.clientDireNotFound.tittle
    </h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container-fluid ESFsinDIRE text-center">
      <img src="assets/images/ico_aviso.png" class="text-center">

      <p [innerHTML]="'pub.clientDireNotFound.body' | translate:{ nif: nif}"></p>
      <a href="{{ direUrl }}" (click)="c('goDire')" class="btn btn-primary" target="_blank" translate><i class="fa fa-list"></i> pub.clientDireNotFound.buttonDire</a>
    </div>
  </div>

  <div class="modal-footer">
  </div>

</ng-template>
<!-- FIN MODAL -->

<!-- MODAL -->
<ng-template #loginOptions let-c="close">


  <div class="modal-header">
    <h5 class="modal-title" id="loginModalLongTitle" translate>pub.login.modalTitle</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" translate>
    pub.login.modalBody
  </div>
  <div class="modal-footer">
    <div class="botonera">
      <button type="button" class="btn btn-especial col-6" (click)="loginClave()"><img src="assets/images/ico_clave.png" alt="icono Clave"></button>
      <button type="button" class="btn btn-especial col-6" (click)="loginCert(); c('close');"><img src="assets/images/ico_certificado.png" alt="icono certificado"></button>
      <a *ngIf="devAuth" [href]="[devAuth]">Dev Login</a>
    </div>
    <div id="clave"></div>
  </div>


</ng-template>
<!-- FIN MODAL -->

<div *ngIf="!hideLogin" class="container-fluid col-12 h5Secciones">
  <h5 [innerHTML]="'pub.home.intro' | translate"></h5>
  <p><a href="https://administracionelectronica.gob.es/ctt/faceb2b#.WwJq9taxVQI" target="_blank" translate>pub.home.btnMoreInfo</a></p>
  <span class="separador"></span>
</div>
<div *ngIf="!hideLogin" class="container-fluid secciones">
  <div class="row">
    <div class="cliente col-6 col-sm-5">

      <div class="imagen">
        <img (click)="redirectToCli()" src="assets/images/ico_cliente.png" alt="imagen cliente">
      </div>
      <div class="cuerpo">
        <h2><span class="d-block zonaCLIENTE_element_to_target" translate="">pub.home.titleClient</span></h2>
        <p class="d-none d-md-block" translate="">pub.home.bodyClient</p>
        <button type="button" class="btn btn-success " (click)="redirectToCli();" translate>pub.home.btnClient</button>
      </div>
    </div>

    <div class="col-sm-2 d-sm-block d-none"></div>
    <div class="empresa col-6 col-sm-5 ">
      <div class="imagen">
        <img (click)="redirectToInv()" src="assets/images/ico_empresa.png" alt="icono Empresa">
      </div>
      <div class="cuerpo">
        <h2><span class="d-none d-md-block zonaESF_element_to_target" translate>pub.home.titleESF</span><span class="d-block d-md-none zonaESF_element_to_target" translate>pub.home.shorttitleESF</span></h2>
        <p class="d-none d-md-block" translate>pub.home.bodyESF</p>
        <button type="button" class="btn btn-success" (click)="redirectToInv();" translate>pub.home.btnESF</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-public/pub-login/pub-login.component.html